import axiosApiInstance from "../../interceptors/axiosApiInstance";
import { BASE_URL } from "../config";


const VariableService = {
    postVariable: async function (data) {
        try {
            const response = await axiosApiInstance.post(await BASE_URL + "/variable", data, data.default_file ? {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            } : {});
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getByVariable: async function (id) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/variable/getbyid/${id}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getVariable: async function (version_id, isInput = false, isOutput = false) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/variable?autom_version_id=${version_id}&type=${isInput ? 'is_input' : ''}${isOutput ? 'is_output' : ''}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getVariableByFilter: async function (ids, filter) {
        try {
            // console.log({ids, filter: { is_output }});
            const response = await axiosApiInstance.post(await BASE_URL + '/variable/filterByIds', {
                ids, filter
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    updateVariable: async function (data, id) {
        try {
            const response = await axiosApiInstance.put(await BASE_URL + `/variable/${id}/edit`, data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    deleteVariable: async function (id) {
        try {
            const response = await axiosApiInstance.delete(await BASE_URL + `/variable/${id}`);
            return response.data;
        } catch (error) {
            return error;
        }
    },
    getVariableType: async function () {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/variable/type`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    updateVariableDefaultValue: async function (data) {
        try {
            // console.log({ids, filter: { is_output }});
            const response = await axiosApiInstance.put(await BASE_URL + '/variable/setDefaultValues', data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getVariableFilter: async function (autom_version_id = "", is_output = 0, is_input = 0) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/variable/filter?autom_version_id=${autom_version_id}&is_input=${is_input}&is_output=${is_output}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    }
}


export default VariableService;

